import PropTypes from 'prop-types';
import { I18n } from 'i18n-js';
import en from './translations/en.json';
import se from './translations/se.json';
import empty from './translations/empty.json';
import { LOCAL_STORE_LANGUAGE } from '../../constants/localStorage';

const lang = localStorage.getItem(LOCAL_STORE_LANGUAGE);

// Create an instance of I18n
const i18n = new I18n();
i18n.defaultLocale = 'se';
i18n.locale = lang || 'se'; // Fallback to 'se' if lang is null
i18n.fallbacks = true;

i18n.translations = {
  en,
  se,
  empty,
};

const propTypes = {
  content: PropTypes.string,
  params: PropTypes.arrayOf(PropTypes.shape({})),
};

function Translate({ content = '', params = null }) {
  return i18n.t(content, params);
}

Translate.propTypes = propTypes;

export default Translate;
